import { Button } from "@mui/material";

/**
 * Clears a saved Gate 1 connector so Gate 2 no longer treats it as declared.
 */
export default function RemoveDetailsButton({
  onClick,
  disabled = false,
  removing = false,
  sx = {},
}) {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled || removing}
      sx={{
        width: "fit-content",
        minWidth: 140,
        height: 32,
        boxSizing: "border-box",
        p: "4px 16px",
        textTransform: "none",
        fontWeight: 700,
        fontFamily: "Lato, sans-serif",
        fontSize: "13px",
        lineHeight: "24px",
        border: "1px solid #B82500",
        color: "#B82500",
        borderRadius: "4px",
        bgcolor: "#FFFFFF",
        "&:hover": {
          border: "1px solid #B82500",
          bgcolor: "#FFF5F3",
        },
        "&.Mui-disabled": {
          border: "1px solid #E6E6E6",
          bgcolor: "#F5F5F5",
          color: "#BBBBBB",
        },
        ...sx,
      }}
    >
      {removing ? "Removing…" : "Remove details"}
    </Button>
  );
}
